meedy.factory('meedy.authInterceptor', [ '$q', '$rootScope', '$injector', 'meedyConfig', '$cookies',
    function ($q, $rootScope, $injector, appConfig, $cookies) {

        this.token = {};
		this.mdxAuthenticated = {value: false};
        var self = this;

        $rootScope.$on(Event.MEEDY.AUTH.AUTHENTICATE.SUCCESS, function (event, token) {
            if(token) {
                self.token = token;
                $cookies.put('meedy_access_token', token.access_token);
                $cookies.put('meedy_refresh_token', token.refresh_token);
                $cookies.put('edm-cookie', token.access_token, {domain: appConfig.DOMAIN, path: '/'});
                sessionStorage.setItem('meedy_refresh_token', token.refresh_token);
                sessionStorage.setItem('meedy_access_token', token.access_token);
                sessionStorage.setItem('edm-cookie', token.access_token);
            }
        });
	
		$rootScope.$on(Event.MEEDY.AUTH.AUTHENTICATE_MDX.SUCCESS, function (event, token) {
            self.mdxAuthenticated.value = true;
            $cookies.put('mdxAuthenticated', self.mdxAuthenticated.value);
			$rootScope.$broadcast(Event.MEEDY.AUTH_INTERCEPTOR.MDX.READY, self.mdxAuthenticated);
		});
        
        $rootScope.$on(Event.MEEDY.AUTH.INVALIDATE.SUCCESS, function (event) {
            self.token = null;
            self.mdxAuthenticated.value = false;
            $cookies.remove('meedy_access_token');
            $cookies.remove('meedy_refresh_token');
            $cookies.remove('edm-cookie');
            $cookies.remove('mdxAuthenticated');
            sessionStorage.removeItem('meedy_refresh_token');
            sessionStorage.removeItem('meedy_access_token');
            sessionStorage.removeItem('edm-cookie');
            
        });

        if(sessionStorage.getItem('meedy_access_token')) {
            this.token.access_token = sessionStorage.getItem('meedy_access_token');
            this.token.refresh_token = sessionStorage.getItem('meedy_refresh_token');
            this.token.access_token = sessionStorage.getItem('edm-cookie');
        }

        if($cookies.get('meedy_access_token')) {
            this.token.access_token = $cookies.get('meedy_access_token');
            this.token.refresh_token = $cookies.get('meedy_refresh_token');
        }
	
		if($cookies.get('mdxAuthenticated')) {
			this.mdxAuthenticated.value = $cookies.get('mdxAuthenticated');
        } else {
			this.mdxAuthenticated.value = false;
        }

        return {
            request: function(config) {
                if(self.token) {
                    if (self.token.access_token && config.url.indexOf(appConfig.API_URL) === 0) {
                        config.headers['Authorization'] = 'Bearer ' + self.token.access_token;
                    } else if (self.token.access_token && $injector.has('edmConstant')) {
                        var edmConfig = $injector.get('config');
                        if (config.url.indexOf(edmConfig.API_URL) === 0) {
                            config.headers['X-AUTH-TOKEN'] = self.token.access_token;
                        }
                    }
                }

                return config;
            },
            token: self.token,
			mdxAuthenticated: self.mdxAuthenticated
        };
    }
]);
